import React, { useState } from 'react';
import { 
  Container, 
  Box, 
  Typography, 
  Button, 
  Stack, 
  IconButton 
} from '@mui/material';
import { 
  CreateNewFolder as CreateNewFolderIcon,
  CloudUpload as CloudUploadIcon, 
  Refresh as RefreshIcon
} from '@mui/icons-material';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { FileProvider, useFiles } from './hooks/useFilesContext.js';
import BreadcrumbNav from './components/BreadcrumbNav.js';
import FileList from './components/FileList.js';
import CreateFolderModal from './components/CreateFolderModal.js';
import UploadModal from './components/UploadModal.js';

function AppContent() {
  const [isFolderModalOpen, setIsFolderModalOpen] = useState(false);
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const { refreshFiles } = useFiles();

  const handleRefresh = () => {
    refreshFiles();
  };

  return (
    <>
      <Box minHeight="100vh" py={5}>
        <Container maxWidth="xl">
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={5}>
            <Typography variant="h4">Gerenciador de Arquivos</Typography>
            <Stack direction="row" spacing={2}>
              <Button
                variant="contained"
                color="primary"
                startIcon={<CreateNewFolderIcon />}
                onClick={() => setIsFolderModalOpen(true)}
                size="small"
              >
                Nova Pasta
              </Button>
              <Button
                variant="contained"
                color="success"
                startIcon={<CloudUploadIcon />}
                onClick={() => setIsUploadModalOpen(true)}
                size="small"
              >
                Upload
              </Button>
              <IconButton 
                color="default" 
                size="small"
                aria-label="Atualizar"
                onClick={handleRefresh}
              >
                <RefreshIcon />
              </IconButton>
            </Stack>
          </Box>

          <BreadcrumbNav />
          <FileList />
        </Container>
      </Box>

      <CreateFolderModal
        open={isFolderModalOpen}
        onClose={() => setIsFolderModalOpen(false)}
      />
      <UploadModal
        open={isUploadModalOpen}
        onClose={() => setIsUploadModalOpen(false)}
      />
    </>
  );
}

function App() {
  return (
    <FileProvider>
      <AppContent />
      <ToastContainer position="bottom-right" />
    </FileProvider>
  );
}

export default App; 